<template>
   <section class="overlay__short-caption">
    <h2>
      <span
        data-overlay-prevent-close
        class="overlay__short-caption__text balance-text"
        v-html="title"
        />
    </h2>
  </section>
</template>

<script>
  export default {
    props: {
      title: {type: String, required: true }
    }
  };
</script>
